<template>
  <panel class="placeholder">
    <metric-placeholder />
  </panel>
</template>

<script>
import Panel from '@/common/components/Panel'
import MetricPlaceholder from '@/common/components/MetricPlaceholder'

export default {
  name: 'KeyMetricPlaceholder',

  components: { Panel, MetricPlaceholder }
}
</script>

<style scoped lang="scss">
$placeholder-colour: #dbdee7;

.placeholder {
  width: 260px;
  height: 88px;
}
</style>



// WEBPACK FOOTER //
// src/common/components/KeyMetricPlaceholder.vue